import { types } from 'mobx-state-tree';
import type { Instance } from 'mobx-state-tree';

export const LoginFormData = types.model('LoginFormData', {
    email: '',
    password: '',
    confirmPassword: types.maybe(types.string),
    loginAttempted: false,
});
export type TypeLoginFormData = Instance<typeof LoginFormData>;

export default LoginFormData;
